
import React from "react";

interface VerseLoaderProps {
  backgroundStyle: React.CSSProperties;
}

export function VerseLoader({ backgroundStyle }: VerseLoaderProps) {
  return (
    <div className="fixed inset-0 flex items-center justify-center" style={backgroundStyle}>
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
    </div>
  );
}
